import { SVGProps } from 'react';

export const SounderApiIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M4.5 5L6.5 6.5L4.5 8M7.5 8H9.5M3.5 13.5H12.5C13.3284 13.5 14 12.8284 14 12V4C14 3.17157 13.3284 2.5 12.5 2.5H3.5C2.67157 2.5 2 3.17157 2 4V12C2 12.8284 2.67157 13.5 3.5 13.5Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
